/**
 * 二手车检测
 */
import { USED_CAR_CHECK } from '../types';

export default {
    name: `${USED_CAR_CHECK}`,
    path: '/usedCarCheck',
    component: () => import('@/views/usedCar/usedCarDetection/'),
    redirect: { name: `${USED_CAR_CHECK}Index` },
    meta: {
        title: '二手车检测',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${USED_CAR_CHECK}Index`,
            path: 'index',
            component: () => import('@/views/usedCar/usedCarDetection/home/Home.vue'),
        },
        {
            name: `${USED_CAR_CHECK}OrderRead`,
            path: 'read',
            component: () => import('@/views/usedCar/usedCarDetection/detail/Detail.vue'),
        },
    ],
};
